import React from 'react'

const Header = () => {
  return (
    <div className="py-4 border-b-2 border-b-gray-300 drop-shadow-md fixed top-0 inset-x-0 bg-white">
      <h1 className="font-bold text-3xl uppercase text-center ">Codehelp Blogs</h1>
    </div>
  )
}

export default Header